<template>
  <div id="app">
    <main id="container" role="main">
      <router-view/>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#nissanHeliosHeader {display:none !important;
}

h3.section-heading {
  font-family: "Nissan Regular", Helvetica, Arial, sans-serif !important
}

.section-heading {
  text-align: center;
  font-size: 16px;
  font-family: 'Nissan Bold';
  margin-top: 5px;

  &::before {
    content: "";
    display: block;
    height: .125em;
    width: 150px;
    background-color: #C3002F;
    margin: 0 auto 1em;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue